(function () {
    'use strict';

    angular
        .module('app')
        .factory('ColaboracionService', ColaboracionService);

    ColaboracionService.$inject = ['$http'];

    function ColaboracionService($http) {

        var service = {

            getColaboraciones: getColaboraciones,
            getTareas: getTareas,
            colaboracionId: colaboracionId,
            // getColaboracionesFinalizadas: getColaboracionesFinalizadas,
            guardartareas: guardartareas,
            getRespuestas: getRespuestas,
            getFirmaContrato: getFirmaContrato,
            getRespuestasByUser: getRespuestasByUser,
            getCategoriacolaboracion: getCategoriacolaboracion,
            firmarContrato: firmarContrato
        };


        function getColaboraciones(user_id) {
            // console.log(vm);
            var config = { headers: {} }
			// console.log(startDate, typeof startDate)
            return $http.get('/ajax/colaboraciones', {
                params: {
                    user_id: user_id,
                    // startDate: moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    // endDate: moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

		function getFirmaContrato(colaboracion_id, tarea_usuario_id, hash)
        {
            // console.log(vm);
            var config = { headers: {} }

            return $http.post('/ajax/firmacontrato', {   
           
				colaboracion_id: colaboracion_id,
				tarea_usuario_id: tarea_usuario_id,
				hash: hash,
	
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };


        function firmarContrato(contratoId, userId) {

            var config = { headers: {} }

            return $http.post('/ajax/firmarcontrato', {

                contratoId: contratoId,
                userId: userId

            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        // function getColaboracionesFinalizadas(vm)
        // {
        //     // console.log(vm);
        //     var config = {headers : {}}

        //     return $http.get('/ajax/colaboracionesfinalizadas', {   
        //         params : { 

        //         }
        //     }, config)
        //     .then(function(data){
        //         return data.data;
        //     },function(data){
        //         return data;
        //     });
        // };

        function getTareas(vm) {
            // console.log(vm);
            var config = { headers: {} }

            return $http.get('/ajax/tareas', {
                params: {
                    id: vm.id,
                    hash: vm.hash
                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function colaboracionId(colaboracion_id) {

            var config = {
                headers: {}
            }

            return $http.get('/ajax/consultaseleccionada', {
                params: {
                    colaboracion_id: colaboracion_id
                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function guardartareas(colaboracion_id, stages, completada, hash) {

            var config = {
                headers: {}
            }

            return $http.post('/ajax/guardartareas', {
                colaboracion: colaboracion_id,
                stages: JSON.stringify(stages),
                completada: completada,
                hash: hash
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function getRespuestas(colaboracion_id, hash) {

            var config = {
                headers: {}
            }

            return $http.get('/ajax/colaboracionesusuario', {
                params: {
                    colaboracion: colaboracion_id,
                    hash: hash,
                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function getRespuestasByUser(user_id) {

            var config = {
                headers: {}
            }

            return $http.get('/ajax/colaboracionesusuario', {
                params: {
                    colaboracion: -1,
                    user_id: user_id
                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function getCategoriacolaboracion() {

            var config = {
                headers: {}
            }

            return $http.get('/ajax/categoriacolaboracion', {
                params: {

                }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };


        return service;
    }

})();
